import React, { useEffect, useState, useRef } from "react";
import InboxList from '../../../globalcomponents/inboxList';
import EmailDetail from '../../../globalcomponents/inboxDetail';
import SentList from '../../../globalcomponents/sentList';
import SentDetail from '../../../globalcomponents/sentDetail';
import { withRouter } from 'react-router-dom';
import { genericApi } from '../../../common/apiconfig';

import CircularProgress from '@material-ui/core/CircularProgress';
import ChipInput from 'material-ui-chip-input';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHoc from '../../../globalcomponents/hoc/formHoc';
import { InputField, AutoOptionsNew } from '../../../globalcomponents/formElements';
import { oldgenericApi } from '../../../common/apiconfig';
import Snackbar from '../../../common/snackbar';

import { connect } from 'react-redux';
import JoditEditor from "jodit-react";
import { editorConfig } from '../../../common/constants';
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Paper, Typography, Button } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import moment from 'moment';
import clsx from "clsx";


const useStyles = makeStyles(theme => ({
  sidebar: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 'full'
  },
  sidebarButton: {
    justifyContent: "flex-start",
    textTransform: "none",
    marginBottom: theme.spacing(1),

    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    }
  },
  sidebarButtonActive: {
    backgroundColor: theme.palette.action.selected,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    "&:hover": {
      backgroundColor: theme.palette.action.selected,
    }
  }
}));


const PatientEmails = (propsobj) => {
    console.log(propsobj,propsobj.patientdata,"patientdata")
  const classes = useStyles();
  const [progress, setProgress] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 10;
  const [inputValue, setInputValue] = useState("");
  const [usersValue, setUsersValue] = useState([]);
  const [open, setOpen] = useState(false)
  const [variant, setVariant] = React.useState("")
  const [msg, setMsg] = useState("")
  const [data, setData] = useState("");
  const [todata, setToData] = useState([]);
  const [ccData, setCcData] = useState([]);
  const [ccInputValue, setCcInputValue] = useState('');
  const [ccUsersValue, setCcUsersValue] = useState([]);
  const [CCdata, setCCdata] = useState([]);
  const [BCCdata, setBCCdata] = useState([]);
  const [hideccbtn, setHideccbtn] = useState(true);
  const [showcc, setShowcc] = useState(false);
  const [hidebccbtn, setHidebccbtn] = useState(true);
  const [showbcc, setShowbcc] = useState(false);
  const [content, setContent] = useState('');
  const [templateData, setTemplateData] = useState([]);
  const [templateId, settemplateId] = useState({});
  const [showNewMail, setShowNewMail] = useState(false);
  const [showInbox, setShowInbox] = useState(true);
  const [showSent, setShowSent] = useState(false);
  const [selectedInboxEmail, setSelectedInboxEmail] = useState(null);
  const [selectedSentEmail, setSelectedSentEmail] = useState(null);
  const [activeTab, setActiveTab] = useState("new");
  const [inboxData, setInboxData] = useState([]);
  const [sentMailData, setSentMailData] = useState([]);
  const editor = useRef(null);
  console.log(inboxData, "inboxData")
  useEffect(() => {
    propsobj.UpdateFormField({ name: "fromtext", value: localStorage.getItem("loggedUserEmail") });
    propsobj.UpdateFormField({ name: "ipSubject", value: "" });
    // callGetTemplatesApi();
    getMails();
    getSentMails();
    // getApiData();
    setData([{...propsobj.formValues.patientdata, name:propsobj.formValues.patientdata.firstName+' '+propsobj.formValues.patientdata.lastName, contactId:propsobj.formValues.patientdata.patientId}])
    setSelectedSentEmail(false);
    setSelectedInboxEmail(false);
  }, [propsobj.formValues.autostudy.studyId,pageNumber]);

  const hocObj = FormHoc(propsobj);

  const textProps = {
    ...hocObj,
    propsobj
  };


//   async function getApiData() {
//     let requestBody = {
//       query: `query {
//         getStudyContact(studyId:"${propsobj.formValues.autostudy.studyId}") {
//           studyId
//           contactId
//           action
//           name
//           status
//           role
//           email
//           phone
//           altno
//           createdBy
//           createdTs
//           modifiedBy
//           modifiedTs
//         }
//         }`
//     };

//     requestBody = JSON.stringify(requestBody);
//     setProgress(true);
//     let res = await genericApi('getStudyContact', requestBody);
//     setProgress(false);
//     if (!res) {
//       // Error handling
//       //console.log('Error')

//     } else {
//       if (res?.data?.getStudyContact?.length) {
//         setData(res?.data?.getStudyContact)
//       } else {
//         setData([])
//       }
//     }
//   }



  const getMails = async () => {
    const { autostudy, autosite } = propsobj.formValues;
    console.log(autostudy.studyId, "studyId")
    let requestBody = `
    query {
      getStudySiteEmails(
        studyId: "${autostudy.studyId}",
        siteId: "${autosite.sponsorAccountId}",
        fromType: "Patient",
        toType: "Site",
        searchStr: "*",
        pageSize: ${pageSize},
        pageNumber: ${pageNumber} ,
      ) {
        fromUser {
          sponsorAccountUserId
          sponsorAccountId
          SponsorAccountName
          firstName
          middleName
          lastName
          email
          phone
          roleId
          role
          language
          portalAccessInd
          invitedBy
          invitedDate
          activated
          primaryContactInd
          createdBy
          createdTs
          modifiedBy
          modifiedTs
          position
        }
        toUser {
          sponsorAccountUserId
          sponsorAccountId
          SponsorAccountName
          firstName
          middleName
          lastName
          email
          phone
          roleId
          role
          language
          portalAccessInd
          invitedBy
          invitedDate
          activated
          primaryContactInd
          createdBy
          createdTs
          modifiedBy
          modifiedTs
          position
        }
        ccUser {
          sponsorAccountUserId
          sponsorAccountId
          SponsorAccountName
          firstName
          middleName
          lastName
          email
          phone
          roleId
          role
          language
          portalAccessInd
          invitedBy
          invitedDate
          activated
          primaryContactInd
          createdBy
          createdTs
          modifiedBy
          modifiedTs
          position
        }
        emailSubject
        emailBody
        createdBy
        timeStamp
        studyId
        siteId
        fromType
        toType
      }
    }
  `;

    requestBody = JSON.stringify({ query: requestBody });
    setProgress(true);

    const res = await oldgenericApi('getStudySiteEmails', requestBody);
    setProgress(false);

    if (res?.data?.getStudySiteEmails) {
      setInboxData(res);
      console.log(res, "res")
        ;
    } else {
      console.error("Failed to fetch study site emails.");
    }
  };

  const getSentMails = async () => {
    const { autostudy, autosite } = propsobj.formValues;
    console.log(autostudy.studyId, "studyId")
    let requestBody = `
      query {
        getStudySiteEmails(
          studyId: "${autostudy.studyId}",
          siteId:"${autosite.sponsorAccountId}",
          fromType: "Site",
          toType: "Patient",
          searchStr: "*"
        ) {
          fromUser {
            sponsorAccountUserId
            sponsorAccountId
            SponsorAccountName
            firstName
            middleName
            lastName
            email
            phone
            roleId
            role
            language
            portalAccessInd
            invitedBy
            invitedDate
            activated
            primaryContactInd
            createdBy
            createdTs
            modifiedBy
            modifiedTs
            position
          }
          toUser {
            sponsorAccountUserId
            sponsorAccountId
            SponsorAccountName
            firstName
            middleName
            lastName
            email
            phone
            roleId
            role
            language
            portalAccessInd
            invitedBy
            invitedDate
            activated
            primaryContactInd
            createdBy
            createdTs
            modifiedBy
            modifiedTs
            position
          }
          ccUser {
            sponsorAccountUserId
            sponsorAccountId
            SponsorAccountName
            firstName
            middleName
            lastName
            email
            phone
            roleId
            role
            language
            portalAccessInd
            invitedBy
            invitedDate
            activated
            primaryContactInd
            createdBy
            createdTs
            modifiedBy
            modifiedTs
            position
          }
          emailSubject
          emailBody
          createdBy
          timeStamp
          studyId
          siteId
          fromType
          toType
        }
      }
    `;

    requestBody = JSON.stringify({ query: requestBody });
    setProgress(true);

    const res = await oldgenericApi('getStudySiteEmails', requestBody);
    setProgress(false);

    if (res?.data?.getStudySiteEmails) {

      setSentMailData(res);
      console.log(res, "res")
        ;
    } else {
      console.error("Failed to fetch study site emails.");
    }
  };



  const autoPropstotemplates = {
    options: templateData,
    default: null,
    freeSolo: false,
    propsobj,
    keys: ['value']
  };

  const sendInvite = async (e) => {
    e.preventDefault();
    const stringifyTodata = todata.map(item => `"${item}"`);
    const stringifyCCdata = CCdata.map(item => `"${item}"`);
    const stringifyBCCdata = BCCdata.map(item => `"${item}"`);
    if (propsobj.formValues.fromtext && stringifyTodata.length > 0) {
      const siteId = propsobj.formValues.autosite?.sponsorAccountId;
      const studyId = propsobj.formValues.autostudy?.studyId;
      const contactIds = usersValue.map(item => `"${item.id}"`);
      const ccContactIds = ccData.map(c => `"${c.id}"`);
      const rawHtml = editor.current.value;
      const cleanedHtml = rawHtml.replace(/^<div>|<\/div>$/g, '');
      const fromType = "Site";
      const toType = "Patient";
      const requestBody = JSON.stringify({
        query: `mutation {
        sendStudySiteEmail(
          fromId: "${localStorage.getItem('loginUserId')}",
          toId: [${contactIds}],
          ccId: [${ccContactIds}],
          bccId: [${stringifyBCCdata}],
          emailSubject: "${propsobj.formValues.ipSubject}",
          emailBody:${JSON.stringify(cleanedHtml)},
          bulkMail: "Y",
          studyId: "${studyId}",
          siteId: "${siteId}",
          fromType: "${fromType}",
          toType: "${toType}"
        ) {
          code
          type
          message
          attributes
        }
      }`
      });

      setProgress(true);
      const res = await oldgenericApi("sendStudySiteEmail", requestBody);
      setProgress(false);

      if (res?.data?.sendStudySiteEmail?.code === "200") {
        setOpen(true)
        setVariant('success')
        setMsg(res?.data?.sendStudySiteEmail?.message)
        setToData([]);
        setCcData([]);
        setBCCdata([]);
        setHideccbtn(true);
        setShowcc(false);
        setContent("");
        editor.current.value = "";
        settemplateId({});
        getSentMails();
        propsobj.UpdateFormField({ name: "useTemplate", value: "" });
         propsobj.UpdateFormField({ name: "ipSubject", value: "" });
      } else {
        alert("Failed to send invite.");
      }
    } else {
      alert('Please Enter From and To');
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    propsobj.history.goBack();
  };

  const handleTemplates = (obj) => {
    settemplateId(obj.selected);
    propsobj.UpdateFormField({ name: obj.name, value: obj.selected });
    setContent(obj.selected.body);
  };

  const handleNewMail = () => {
    setShowInbox(false);
    setShowSent(false);
    setShowNewMail(true);
    setSelectedInboxEmail(false);
    setSelectedSentEmail(null);
  }

  const handleOpenInbox = () => {
    setShowNewMail(false);
    setShowInbox(true);
    setShowSent(false);
    setSelectedInboxEmail(null);

  }

  const handleOpenSent = () => {
    setActiveTab("sent");
    setShowInbox(false);
    setShowNewMail(false);
    setShowSent(true);
    setSelectedInboxEmail(null);
    setSelectedSentEmail(null);
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const formatDate = (timestamp) => {
    return moment(timestamp).format("MMM DD/YY");
  };

  const getSuggestions = (input) => {
    const query = input.toLowerCase();
    return data
      .filter((c) => c.name.toLowerCase().includes(query))
      .map((c) => ({
        label: `${c.name} <${c.email}>`,
        value: c.email,
        id: c.contactId
      }));
  };
  console.log(data, "datadata")


  return (
    <>
      {progress && (
        <div className="fullScreen">
          <CircularProgress className="progressCircle" size={100} thickness={1.5} />
        </div>
      )}
      <Snackbar open={open} variant={variant} message={msg} handleClose={handleClose} />

      <div className="d-flex mb-3 justify-content-end">
        {/* <h1 className="mr-auto secondary-header">Emails</h1> */}
      </div>

      <Grid container className={classes.root} spacing={2}>
        {/* Sidebar */}
        <Grid item xs={12} sm={12} md={2}>
          <Paper className={classes.sidebar}>
            <Button
              className={clsx(classes.sidebarButton, {
                [classes.sidebarButtonActive]: activeTab === "new"
              })}
              startIcon={<AddIcon />}
              onClick={() => { setActiveTab("new"); handleNewMail(); }}
              fullWidth
            >
              New Mail
            </Button>

            <Button
              className={clsx(classes.sidebarButton, {
                [classes.sidebarButtonActive]: activeTab === "inbox"
              })}
              onClick={() => { setActiveTab("inbox"); handleOpenInbox(); }}
              fullWidth
            >
              Inbox
            </Button>

            <Button
              className={clsx(classes.sidebarButton, {
                [classes.sidebarButtonActive]: activeTab === "sent"
              })}
              onClick={handleOpenSent}
              fullWidth
            >
              Sent Items
            </Button>
          </Paper>
        </Grid>
        <InboxList
          showInbox={showInbox}
          selectedEmail={selectedInboxEmail}
          showNewMail={showNewMail}
          mailData={inboxData}
          pageNumber={pageNumber}
          pageSize={pageSize}
          setPageNumber={setPageNumber}
          setSelectedEmail={setSelectedInboxEmail}
          setShowNewMail={setShowNewMail}
          formatDate={formatDate}
        />
        <EmailDetail
          selectedEmail={selectedInboxEmail}
          formatDate={formatDate}
          onClose={() => setSelectedInboxEmail(null)}
        />
        {showNewMail && (
          <Grid item xs={12} sm={12} md={10}>
            <Typography variant="h6" style={{ backgroundColor: '#D3D3D3', paddingLeft: '6px' }}>New Message</Typography>
            <form>
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12 emailcompose">
                      <InputField {...textProps} name="fromtext" must={'true'} type="text" InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <div style={{ color: "#C0C0C0" }} className="font14">From</div>
                          </InputAdornment>
                        )
                      }} />
                      <div style={{ paddingTop: '30px' }}>
                        <Autocomplete
                          multiple
                          limitTags={2}
                          id="multiple-limit-tags"
                          value={todata}
                          options={getSuggestions(inputValue)}
                          inputValue={inputValue}
                          onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                          getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.label
                          }
                          isOptionEqualToValue={(option, value) => option.value === value.value}
                          onChange={(event, value) => {

                            const uniqueValues = value.filter(
                              (v, i, self) => i === self.findIndex((o) => o.value === v.value)
                            );
                            console.log(uniqueValues,"uniqueValues")
                            setUsersValue(uniqueValues);
                            setToData(uniqueValues);
                          }}

                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              label=""
                              placeholder=""
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <>
                                    <InputAdornment position="start">
                                      <div style={{ color: "#C0C0C0" }} className="font14">To</div>
                                    </InputAdornment>
                                    {params.InputProps.startAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />





                      </div>
                      <div style={{ paddingTop: '30px' }}>
                        <Autocomplete
                          multiple
                          limitTags={2}
                          id="multiple-cc-tags"
                          value={ccData}
                          options={getSuggestions(ccInputValue)}
                          inputValue={ccInputValue}
                          onInputChange={(event, newInputValue) => setCcInputValue(newInputValue)}
                          getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.label
                          }
                          isOptionEqualToValue={(option, value) => option.value === value.value}
                          onChange={(event, value) => {
                            const uniqueValues = value.filter(
                              (v, i, self) => i === self.findIndex((o) => o.value === v.value)
                            );
                            setCcUsersValue(uniqueValues);
                            setCcData(uniqueValues);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              label=""
                              placeholder=""
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <>
                                    <InputAdornment position="start">
                                      <div style={{ color: "#C0C0C0" }} className="font14">Cc</div>
                                    </InputAdornment>
                                    {params.InputProps.startAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />
                      </div>

                      <div style={{ paddingTop: '30px' }}>
                        <InputField {...textProps} name="ipSubject" must={'false'} type="text" InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">

                              <div style={{ color: "#C0C0C0" }} className="font14">Subject</div>

                            </InputAdornment>
                          )
                        }} style={{ paddingTop: "30px" }} />
                      </div>
                      <br />

                      <div>
                        {/* <textarea class="form-control" style={{ height: "200px" }} placeholder="text message goes here" name="compose" value={compose} onChange={(e) => { setCompose(e.target.value) }} /> */}
                        <JoditEditor
                          ref={editor}
                          value={content}
                          config={editorConfig}
                          // tabIndex={1} // tabIndex of textarea
                          // onChange={(e) => { newhandle(e) }}
                          onBlur={newContent => setContent(newContent)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br /> <div className="buttonContainer mr-auto" style={{
                display: "flex",
                justifyContent: "flex-end"
              }}>
                <button type="submit" className="btn btn-primary-blue btn-rounded btn-small mr-1" onClick={sendInvite}>SEND</button>
                {/* <button className="btn btn-primary-grey btn-rounded btn-small" onClick={handleCancel}>CANCEL</button> */}
              </div>
            </form>
          </Grid>
        )}
        <SentList
          showSent={showSent}
          selectedEmail={selectedSentEmail}
          mailData={sentMailData}
          setSelectedEmail={setSelectedSentEmail}
          formatDate={formatDate}
        />
        {showSent && selectedSentEmail && (
          <SentDetail
            selectedEmail={selectedSentEmail}
            formatDate={formatDate}
            onClose={() => setSelectedSentEmail(null)}
          />
        )}
      </Grid>
    </>
  );
};

const mapStateToProps = (state) => ({
  formValues: state.form,
  state
});

const mapDispatchToProps = (dispatch) => ({
  UpdateFormField: (obj) => dispatch({ type: 'UpdateFormField', value: obj.value, name: obj.name }),
  clearForm: () => dispatch({ type: 'ClearForm' }),
  updateErrorObj: (obj) => dispatch({ type: 'updateErrorObj', flag: obj.flag, name: obj.name, text: obj.text }),
  updateEntireErrorObj: (errobj, errtextobj) => dispatch({ type: 'updateEntireErrorObj', errobj, errtextobj })
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PatientEmails));
